import React from 'react'
import {Link} from 'gatsby'
import buttonsStyle from "../components/css/buttonsStyle.module.scss"
import learnMoreBoxStyle from "../components/css/learnMoreBoxStyle.module.scss";

export default function({children, cta, link, coverImage}){
    
    return (
        <div className={learnMoreBoxStyle.offer}>
        {coverImage &&
            <div className={learnMoreBoxStyle.cover} style={{backgroundImage: "url(/assets/"+coverImage+")"}}></div>
        }
        <article className={learnMoreBoxStyle.article}>
            {children}
        
            <Link to={link} className={buttonsStyle.btn + " "+buttonsStyle.primary}>{cta}</Link>
        </article>  
        </div>      
    )
}